import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { PapiGallection } from '@wix/da-papi-types';
import { AppState } from '../../../../types/store';
import { getSelectedFolder, getIsRootStashFolder } from '../../../../selectors/studio';
import { getHasSubfolders } from '../../../../selectors/stash';
import { Props } from './StashHeader';

export type StateProps = Pick<Props, 'selectedFolder' | 'hasSubfolders' | 'isRootStashFolder'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  selectedFolder: getSelectedFolder(state) as PapiGallection,
  hasSubfolders: getHasSubfolders(state),
  isRootStashFolder: getIsRootStashFolder(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
